import React from 'react';
import { Modal } from '../../components/ui/Modal';
import { useForm } from 'react-hook-form';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { inviteTeacher } from '../../modules/platform/api/schools';
import { showErrorToast, showSuccessToast } from '../../utils/errorHandler';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  schoolId?: string;
  onInvited?: () => void;
}

export const InviteModal: React.FC<Props> = ({ isOpen, onClose, schoolId, onInvited }) => {
  const { register, handleSubmit, formState, reset } = useForm<{ email: string }>();

  const onSubmit = async (data: { email: string }) => {
    if (!schoolId) {
      showErrorToast(new Error('School not selected'));
      return;
    }
    try {
      await inviteTeacher(schoolId, data.email);
      showSuccessToast('Invite sent successfully!');
      reset();
      onInvited?.();
      onClose();
    } catch (err) {
      showErrorToast(err);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Invite Teacher" size="md">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Input
          label="Email Address"
          type="email"
          {...register('email', { required: 'Email is required' })}
          error={formState.errors.email?.message}
          placeholder="teacher@school.com"
        />
        <div className="flex gap-2 justify-end pt-4">
          <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
          <Button type="submit">Send Invite</Button>
        </div>
      </form>
    </Modal>
  );
};


